<template>
  <el-select
    v-model="selected"
    size="small"
    @change="handleChange"
    placeholder="选择区域"
    style="width: 100%"
    :popper-append-to-body="false"
    :clearable="clearable"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { userAreas } from '@/service/getData'
import { isMobile } from '@/util/index'

export default {
  props: {
    val: '',
    showNoAreaSelect: Boolean,
    clearable: Boolean,
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      }
    },
  },
  data() {
    return {
      isMobile,
      selected: '',
      lists: [],
      selectedLabel: '',
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange() {
      this.updateSelectedLabel()
      this.$emit('change', this.selected)
    },
    updateSelectedLabel() {
      for (let index = 0; index < this.lists.length; index++) {
        const item = this.lists[index]
        if (item.id == this.selected) {
          this.selectedLabel = item.name
          break
        }
      }
    },
    async requestData() {
      let res = await userAreas()
      if (res.code == 0) {
        if (this.showNoAreaSelect) {
          res.data.list.unshift({ id: -1, name: '无区域或无省份' })
        }
        this.lists = res.data.list || []
        if (this.val) {
          this.selected = this.val
          this.updateSelectedLabel()
        }
      }
    },
  },
}
</script>